import React from 'react';
import { useAssessmentContent } from './content/context';

const AssessmentFooter: React.FC = () => {
  const { footerCopyright } = useAssessmentContent();
  return (
    <footer className="bg-a-navy-dark flex items-center justify-center" style={{ padding: '14px 40px' }}>
      <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.3)' }}>
        © {new Date().getFullYear()} {footerCopyright}
      </div>
    </footer>
  );
};

export default AssessmentFooter;
